import * as FullStoryClient from '@fullstory/browser';

import features from 'core/features';
import useUserRedux from 'hooks/useUserRedux';
import { PRODUCTION } from 'services/constants';
import getFullName from 'utils/getFullName';
import { ensureObject } from 'utils/objects';

const FULL_STORY_ID = '4NH66';

const FullStory = () => {
  const { data: user, isLoggedIn } = useUserRedux();
  const { email } = ensureObject(user);

  const userName = isLoggedIn ? getFullName(user) : null;
  const stagingSessionKey = `${email}_staging_env`;

  const userData = { displayName: userName, email };
  const sessionUid = features.fullStoryEnabled ? stagingSessionKey : email;

  const shouldInitFullStory =
    (ENVIRONMENT === PRODUCTION || features.fullStoryEnabled) && userName;

  if (shouldInitFullStory) {
    // Initialize FullStoryClient on browser with the static orgId for FullStory
    FullStoryClient.init({
      orgId: FULL_STORY_ID,
    });
    // Identify FS initialized client with the sessionUid(email) and userData(displayName, email)
    window.FS.identify(sessionUid, userData);
  }

  return null;
};

export default FullStory;
